import Button from "@/components/ui/button";
import DialogClose from "../DialogClose";
import styles from "./DialogCommonContent.module.scss";

type Props = {
	message: string;
	applyMessage: string;
	warning?: boolean;
	closeOnly?: boolean;
	onClick?: () => void;
};

/**
 * ダイアログの内容の共通 コンポーネント
 * @returns {JSX.Element} ダイアログの内容の共通 コンポーネント
 */
export default function DialogCommonContent(props: Props) {
	const { message, applyMessage, warning, closeOnly, onClick } = props;

	return (
		<div className={styles.dialog}>
			<p className={styles.message}>{message}</p>
			<div
				className={
					closeOnly ? styles.closeOnlyDialog : styles.normalDialog
				}
			>
				<DialogClose>
					<Button className={styles.actionBtn}>
						{closeOnly ? applyMessage : "キャンセル"}
					</Button>
				</DialogClose>
				{!closeOnly && (
					<Button
						className={`${styles.actionBtn} ${
							warning ? styles.resetBtn : styles.registBtn
						}`}
						type="submit"
						onClick={onClick}
					>
						{applyMessage}
					</Button>
				)}
			</div>
		</div>
	);
}
